import React, { useContext } from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'astroturf/react';
import { FeedContext } from 'js/social/contexts/feed';
import { FollowableUser } from 'js/social/shared/types';
import UserTooltip from 'js/social/shared/UserTooltip';
import { Menu } from 'js/design_system/Menu';
import { PopoverMode } from 'js/design_system/Popover';
import { Link } from './Link';
import _Tag from "TagElement-Tag.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TagElement.tsx?styleId=Tag";


const Tag = /*#__PURE__*/styled(Link, null, {
  displayName: "Tag",
  styles: _Tag
});

export const TagElement: React.FC<RenderElementProps> = ({
  attributes,
  element,
  children,
}) => {
  const {
    userActions: { getUserData },
  } = useContext(FeedContext);

  const text = element.data.text;
  const url = element.data.url;
  if (text !== undefined && url !== undefined) {
    // We're rendering in admin pages
    return (
      <Tag {...(({ ref: _, ...rest }) => rest)(attributes)} href={url}>
        {text}
        {children}
      </Tag>
    );
  } else {
    // TODO: Use `element.data.tagType` for papers and other tags
    const user: Partial<FollowableUser> = getUserData(element.data.tagId);
    return (
      <Menu
        placement="bottom-start"
        mode={PopoverMode.Hover}
        offset={4}
        inline
        render={() => <UserTooltip user={user} />}
      >
        <Tag
          {...(({ ref: _, ...rest }) => rest)(attributes)}
          contentEditable={false}
          href={user.url}
        >
          {user.displayName}
          {children}
        </Tag>
      </Menu>
    );
  }
};
